<template>
  <g>
    <path
      d="M12.5788 10.5824C10.8764 10.5824 9.49185 9.19768 9.49185 7.5C9.49185 5.80232 10.8764 4.41763 12.5788 4.41763C14.2798 4.41763 15.6566 5.80089 15.6566 7.5C15.6566 9.19839 14.2713 10.5824 12.5788 10.5824ZM12.5788 5.24508C11.4032 5.24508 10.506 6.29587 10.506 7.5C10.506 8.70254 11.3925 9.75492 12.5788 9.75492C13.7573 9.75492 14.6424 8.70095 14.6424 7.5C14.6424 6.29905 13.7573 5.24508 12.5788 5.24508Z"
      :fill="iconColor"
      :stroke="borderColor"
      stroke-width="0.835255"
    />
    <path
      d="M16.9795 19.2095H8.0256C7.58291 19.2095 7.22375 18.867 7.19034 18.4327C7.12352 17.4638 7.0567 16.4949 6.98988 15.5427C6.90635 14.3734 7.78337 13.0704 8.93603 12.6444C11.233 11.8175 13.7638 11.8258 16.044 12.6444C17.2051 13.0704 18.0821 14.3734 17.9985 15.5511L17.7981 18.4411C17.7814 18.867 17.4139 19.2095 16.9795 19.2095ZM8.80238 17.539H16.1944L16.3364 15.4258C16.3614 15.0666 16.0106 14.3984 15.4761 14.2063C13.5633 13.5214 11.4334 13.5214 9.504 14.2063C8.97779 14.3984 8.62698 15.0666 8.65204 15.4258C8.71051 16.1191 8.75227 16.829 8.80238 17.539Z"
      :fill="iconColor"
    />
    <path
      d="M22.3921 17.8501H18.8255C18.5916 17.8501 18.4079 17.6664 18.4079 17.4325C18.4079 17.1986 18.5916 17.0149 18.8255 17.0149H21.9995L22.1415 14.91C22.1749 14.4506 21.7656 13.7574 21.206 13.5486C20.3958 13.2562 19.5438 13.1059 18.6752 13.0892C18.4413 13.0892 18.2575 12.8971 18.2659 12.6632C18.2743 12.4377 18.458 12.2539 18.6835 12.2539H18.6919C19.6524 12.2706 20.5963 12.4377 21.49 12.7634C22.3587 13.0808 23.0436 14.0915 22.9767 14.9685L22.8013 17.4659C22.793 17.6831 22.6176 17.8501 22.3921 17.8501Z"
      :fill="iconColor"
      :stroke="borderColor"
      stroke-width="0.835255"
    />
    <path
      d="M19.9219 11.3398C18.5455 11.3398 17.4219 10.2148 17.4219 8.83984C17.4219 7.46484 18.5455 6.33984 19.9219 6.33984C21.2983 6.33984 22.4219 7.46484 22.4219 8.83984C22.4219 10.2148 21.2983 11.3398 19.9219 11.3398ZM19.9219 7.16484C19.0605 7.16484 18.3582 7.91484 18.3582 8.83151C18.3582 9.74818 19.0605 10.4982 19.9219 10.4982C20.7833 10.4982 21.4855 9.74818 21.4855 8.83151C21.4855 7.91484 20.7833 7.16484 19.9219 7.16484Z"
      :fill="iconColor"
      :stroke="borderColor"
      stroke-width="0.835255"
    />
    <path
      d="M6.16309 17.8496H2.59655C2.37939 17.8496 2.19563 17.6825 2.17893 17.457L2.00352 14.9679C1.94506 14.0909 2.62161 13.0886 3.49028 12.7712C4.39235 12.4455 5.33619 12.2784 6.29674 12.2617C6.53896 12.2951 6.71436 12.4371 6.72272 12.671C6.72272 12.9049 6.54731 13.0886 6.31344 13.097C5.44478 13.1137 4.59281 13.264 3.78262 13.5564C3.21464 13.7568 2.81372 14.4501 2.83878 14.9095L2.98077 17.0143H6.15474C6.38861 17.0143 6.57237 17.1981 6.57237 17.4319C6.58072 17.6658 6.38861 17.8496 6.16309 17.8496Z"
      :fill="iconColor"
      :stroke="borderColor"
      stroke-width="0.835255"
    />
    <path
      d="M5.60547 11.3398C4.22906 11.3398 3.10547 10.2148 3.10547 8.83984C3.10547 7.46484 4.22906 6.33984 5.60547 6.33984C6.98187 6.33984 8.10547 7.46484 8.10547 8.83984C8.10547 10.2148 6.99124 11.3398 5.60547 11.3398ZM5.60547 7.16484C4.74405 7.16484 4.0418 7.91484 4.0418 8.83151C4.0418 9.74818 4.74405 10.4982 5.60547 10.4982C6.46689 10.4982 7.16914 9.74818 7.16914 8.83151C7.16914 7.91484 6.46689 7.16484 5.60547 7.16484Z"
      :fill="iconColor"
      :stroke="borderColor"
      stroke-width="0.835255"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#616161"
    },

    borderColor: {
      type: String,
      default: "#616161"
    }
  }
};
</script>
